import { render, staticRenderFns } from "./PopupMessage.vue?vue&type=template&id=ca3f3b92&scoped=true&"
import script from "./PopupMessage.vue?vue&type=script&lang=js&"
export * from "./PopupMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3f3b92",
  null
  
)

export default component.exports